import React from 'react';

import { Grid, Typography } from '@mui/material';

import { VerificationItem } from '@pages/Auth/ForgotPasswordPage/styles';

import ArrowIcon from 'jsx:@assets/svgs/arrowRight.svg';

import MFA_METHODS_ENUM from '../../enums/MFA_METHODS.enum';
import { useMFAMethodsInfo } from './hooks/useMFAMethodsInfo';

function MFASelector({
	availableMFAMethods,
	isUnauthenticated,
}: {
	availableMFAMethods?: MFA_METHODS_ENUM[];
	isUnauthenticated?: boolean;
}) {
	const mfaMethodsInfo = useMFAMethodsInfo({ availableMFAMethods, isUnauthenticated });

	if (availableMFAMethods && availableMFAMethods.length === 0)
		return (
			<Typography variant="body1" mb={2} sx={{ fontSize: 16, fontWeight: 400 }}>
				No available methods. Please contact your administrator for more details or assistance.
			</Typography>
		);
	else {
		return (
			<Grid container mb={1}>
				<Grid item xs={12} mt={4}>
					<Typography variant="body1" mb={2} sx={{ fontSize: 16, fontWeight: 400 }}>
						Please select verification method:
					</Typography>
				</Grid>
				{mfaMethodsInfo.map(({ method, Icon, onClick }) => (
					<Grid item xs={12} mb={2} key={method}>
						<VerificationItem onClick={onClick}>
							<Grid item display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{ maxHeight: 20 }}>
								<Icon />
								<Typography variant="caption" ml={2} textTransform={'uppercase'}>
									<b>{method}</b>
								</Typography>
							</Grid>
							<ArrowIcon />
						</VerificationItem>
					</Grid>
				))}
			</Grid>
		);
	}
}

export default MFASelector;
